<script setup lang="ts">
import type { NuxtError } from "#app";
import type { PropType } from "vue";

defineProps({
  error: {
    type: Object as PropType<NuxtError>,
    default: () => ({ statusCode: 500, statusMessage: "Unknown error" }),
  },
});

const handleError = () => clearError({ redirect: "/" });
</script>

<template>
  <div class="p-10 text-center">
    <UAlert
      color="error"
      variant="subtle"
      :title="error?.statusCode"
      :description="error?.statusMessage"
      icon="i-lucide-message-square-warning"
    />
    <UButton @click="handleError"> Clear errors </UButton>
  </div>
</template>
